export default __webpack_public_path__ + "static/media/live_stream_2.284f9d79.jpg";